export { default } from './lazy-load-component';